<template>
  <div class="home-block">
    <div class="title" @click="toBlockListPage()">
      {{$t("lastData.block")}}
      <img src="../../assets/images/common/search.png" />
    </div>
    <div class="data">
      <div
        v-for="(block,index) in listdata"
        v-bind:key="index"
        class="item click-able"
        @click="toBlockDetailPage(block.block_height)"
      >
        <div class="logo-content">
          <div class="logo">
            <div class="text">Bk</div>
          </div>
        </div>
        <div class="data-content">
          <div class="up">{{$HelperTools.toFinancialVal(block.block_height)}}</div>
          <!-- <div>{{showtime[index]}}s ago</div> -->
          <div class="down">
            <div class="left">{{block.block_size}} byte</div>
            <div class="right">
              <div class="txcount">{{block.tx_count}} Txns</div>
              <div
                class="time"
              >{{showtime[index] &lt; 60 ? showtime[index]+'s':$HelperTools.getShowDate(showtime[index])}} ago</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="more click-able" @click="toBlockListPage()">More></div> -->
  </div>
</template>

<script>
export default {
  props: {
    listdata: {
      type: Array
    }
  },
  data() {
    return {
      showtime: [0, 0, 0, 0, 0]
    };
  },
  watch: {
    listdata: function() {
      clearInterval(this.intervalBlockstandard);
      for (var i = 0; i < 5; i++) {
        this.showtime[i] = this.$HelperTools.getDateTime(
          this.listdata[i].block_time
        );
      }
      this.intervalBlockstandard = setInterval(() => {
        for (var i = 0; i < 5; i++) {
          var time = this.showtime[i] + 1;
          this.$set(this.showtime, i, time);
        }
      }, 1000);
    }
  },
  methods: {
    toBlockListPage() {
      if (this.$route.params.net === "testnet") {
        this.$router.push({
          name: "blockListDetailTest",
          params: { pageSize: 20, pageNumber: 1, net: "testnet" }
        });
      } else {
        this.$router.push({
          name: "blockList",
          params: { pageSize: 20, pageNumber: 1 }
        });
      }
    },
    toBlockDetailPage($blockHeight) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "blockDetail",
          params: { param: $blockHeight }
        });
      } else {
        this.$router.push({
          name: "blockDetailTest",
          params: { param: $blockHeight, net: "testnet" }
        });
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalBlockstandard);
  }
};
</script>

<style lang="less" scoped>
.click-able {
  cursor: pointer;
  transition: all ease 0.3s;
}
.click-able:hover {
  opacity: 0.5;
  transition: all ease 0.3s;
}
.home-block {
  .title {
    cursor: pointer;
    position: relative;
    font-size: 16px;
    font-family: Avenir-Medium, Avenir;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 19px;
    transition: all ease 0.3s;
    img {
      width: 12px;
      height: 12px;
      position: absolute;
      top: 4px;
      right: 0;
    }
  }
  .title:hover {
    opacity: 0.5;
    transition: all ease 0.3s;
  }

  .data {
    padding-top: 50px;
    .item:last-child {
      margin-bottom: 0px;
      .logo-content{
        padding-bottom: 0px;
      }
      .data-content {
        padding-bottom: 0px;
        border-bottom: none;
        }
    }
    .item {
      margin-bottom: 19px;
      display: flex;
      .logo-content {
        width: 60px;
      padding-bottom: 19px;
        .logo {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          background: rgba(250, 250, 250, 1);
          border: 1px solid rgba(242, 242, 242, 1);
          margin-right: 20px;
          margin-top:2px;
          display: flex;
          align-items: center;
          justify-content: center;
          .text {
            font-size: 16px;
            font-family: Avenir, sans-serif;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            line-height: 19px;
            transform: translateY(2px);
          }
        }
      }
      .data-content {
        flex:1;
      padding-bottom: 20px;
        border-bottom: 1px solid #fafafa;
        .up {
          font-size: 16px;
          font-family: DINPro, DINPro;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          line-height: 21px;
        }
        .down {
          padding-top: 10px;
          display: flex;
          justify-content: space-between;
          .left {
            font-size: 12px;
            font-family: Avenir;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.3);
            line-height: 14px;
          }
          .right {
            font-size: 12px;
            font-family: Avenir;
            font-weight: 400;
            line-height: 14px;
            display: flex;
            .txcount {
              color: rgba(0, 0, 0, 0.6);
              padding-right: 10px;
            }
            .time {
              color: rgba(0, 0, 0, 0.3);
            }
          }
        }
      }
    }
  }
  .more {
    font-size: 14px;
    font-family: Avenir-Medium, Avenir;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 16px;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/blocks.vue